<div class="ui inverted dimmer" [class.active]='loading'>
    <div class="ui text loader">Loading</div>
</div>

<div class="jumbotron bg-white text-center p-0 m-0">
    <!-- <h1 class="display-4">Corona Covid-19 Tracker</h1> -->
    <hr>
    <app-dashboard-card [totalConfirmed]='totalConfirmed' [totalActive]='totalActive' [totalRecovered]='totalRecovered' [totalDeaths]='totalDeaths'></app-dashboard-card>
</div>

<hr>
<div class="ui form">
    <div class="card">
        <div class="card-body">
            <div class="inline fields">
                <label for="fruit">Select Case Type : </label>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" id='c' #c (click)='updateChart(c)' value="c" name="casetype" checked="" tabindex="0" class="hidden">
                        <label for='c'>Confirmed</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" value='d' #d (click)='updateChart(d)' id='d' name="casetype" tabindex="0" class="hidden">
                        <label for='d'>Deaths</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" value='r' #r (click)='updateChart(r)' id='r' name="casetype" tabindex="0" class="hidden">
                        <label for='r'>Recovered</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input id='a' #a type="radio" (click)='updateChart(a)' value='a' name="casetype" tabindex="0" class="hidden">
                        <label for='a'>Active</label>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <google-chart [type]='chart.PieChart' [options]='chart.options' style="width: 100%;" [height]='chart.height' [data]='datatable'></google-chart>
                </div>
                <div class="col-md-8">
                    <google-chart [type]='chart.ColumnChart' style="width: 100%;" [options]='chart.options' [height]='chart.height' [data]='datatable'></google-chart>
                </div>
            </div>
        </div>
    </div>
</div>
